export default {"src":"/_next/static/media/skype.e91fdaf6.svg","height":1000,"width":991,"blurWidth":0,"blurHeight":0};